import { MtGroup, MtUser } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { GroupFilters, UserFilters } from "client/store"
import * as types from "./types"


export const setUserGroupList = (userGroupList: types.UserGroupList) => ({
    type: inferLiteral(types.USER_GROUP_LIST),
    userGroupList,
})
export const setAccountGroupList = (accountGroupList: types.AccountGroupList) => ({
    type: inferLiteral(types.ACCOUNT_GROUP_LIST),
    accountGroupList,
})
export const setGroupUserList = (groupUserList: types.GroupUserList) => ({
    type: inferLiteral(types.GROUP_USER_LIST),
    groupUserList,
})

// user groups

export const setAssignedUserGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_USER_GROUP_IDS),
    groupIds,
})
export const setAssignedUserGroupSort = (sortColumn: keyof MtGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_USER_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedUserGroupFilters = (filters: GroupFilters) => ({
    type: inferLiteral(types.ASSIGNED_USER_GROUP_FILTERS),
    filters,
})
export const setNotAssignedUserGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_GROUP_IDS),
    groupIds,
})
export const setNotAssignedUserGroupSort = (sortColumn: keyof MtGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedUserGroupFilters = (filters: GroupFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_GROUP_FILTERS),
    filters,
})
export const setNotAssignedUserGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_GROUP_SELECTED),
    selected,
})

// group users

export const setAssignedGroupUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_GROUP_USER_IDS),
    userIds,
})
export const setAssignedGroupUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_GROUP_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedGroupUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.ASSIGNED_GROUP_USER_FILTERS),
    filters,
})
export const setNotAssignedGroupUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_GROUP_USER_IDS),
    userIds,
})
export const setNotAssignedGroupUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_GROUP_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedGroupUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_GROUP_USER_FILTERS),
    filters,
})
export const setNotAssignedGroupUserSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_GROUP_USER_SELECTED),
    selected,
})

// reload lists

export const setUserGroupReloadList = (value: boolean) => ({
    type: inferLiteral(types.USER_GROUP_RELOAD_LIST),
    value,
})
export const setGroupUserReloadList = (value: boolean) => ({
    type: inferLiteral(types.GROUP_USER_RELOAD_LIST),
    value,
})
